import React, { useState } from 'react';
import {
  AccountSettingsTab,
  AccountSettingsTabContent,
  AccountSettingsTabHeader,
  AccountSettingsTabHeaderLeft,
  AccountSettingsTabHeaderRight,
  AccountSettingsTableContainer,
  AccountSettingsTabSubtitle,
  AccountSettingsTabTitle,
} from '../../../../layouts/accountSettingsLayout/accountSettingsTab/accountSettingsTab';
import { Button, SearchInput, Text, Icon, countries, Flag } from '@bloobirds-it/flamingo-ui';
import styles from '../businessAssetsPage.module.css';
import { ExampleBusinessAsset } from '../exampleBusinessAsset/exampleBusinessAsset';
import { useOpenBuyerPersonaModal } from '../../../../hooks/useSteppableModal';
import { BuyerPersonasList } from './buyerPersonasList/buyerPersonasList';
import { BuyerPersonaModal } from './buyerPersonaModal/buyerPersonaModal';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import BuyerPersonasModal from '../../../../components/buyerPersonasModal/buyerPersonasModal';
import { useBuyerPersonasModal } from '../../../../hooks/useBuyerPersonasModal';
import { BuyerPersonasButton } from '../../../../components/buyerPersonasButton/buyerPersonasButton';

const BuyerPersonaTab = () => {
  const {
    modalOpen,
    handleCloseBuyerPersonaModal,
    handleOpenCreateEditModal,
    isCreation,
  } = useOpenBuyerPersonaModal();
  const [showExamplePage, setShowExamplePage] = useState();
  const [lenguage, setLenguage] = useState();
  const [searchValue, setSearchValue] = useState();
  const { isSmallDesktop } = useMediaQuery();
  const { isOpen: isOpenBuyerPersonasModal, closeBuyerPersonasModal } = useBuyerPersonasModal();

  return (
    <AccountSettingsTab>
      {!showExamplePage ? (
        <>
          <AccountSettingsTabHeader>
            <AccountSettingsTabHeaderLeft>
              <AccountSettingsTabTitle icon="person" color="purple">
                <div className={styles._business_asset_title}>
                  Buyer Personas
                  <BuyerPersonasButton size="small" textBefore="Check your" />
                </div>
              </AccountSettingsTabTitle>
              <AccountSettingsTabSubtitle>
                A buyer persona is a fictional representation of your ideal client or target
                audience! There are multiple Buyer personas within a target company. For example,
                our location intelligence software client has identified sales managers, trade
                marketing managers, and brand managers as their ideal buyers within FMCG target
                companies.{' '}
                <span onClick={() => setShowExamplePage(true)}>
                  <Text htmlTag="span" size="xs" color="purple" className={styles._link}>
                    See some examples
                  </Text>
                </span>
              </AccountSettingsTabSubtitle>
            </AccountSettingsTabHeaderLeft>
            <AccountSettingsTabHeaderRight>
              <SearchInput
                width={200}
                placeholder="Search"
                onChange={value => setSearchValue(value)}
              />
              <Button
                iconLeft="plus"
                onClick={() => handleOpenCreateEditModal({ isCreationType: true })}
                color="purple"
              >
                {!isSmallDesktop && 'New Buyer Persona'}
              </Button>
            </AccountSettingsTabHeaderRight>
          </AccountSettingsTabHeader>
          <AccountSettingsTabContent>
            <AccountSettingsTableContainer>
              <BuyerPersonasList
                setShowExamplePage={setShowExamplePage}
                searchValue={searchValue}
              />
            </AccountSettingsTableContainer>
          </AccountSettingsTabContent>
          {modalOpen && (
            <BuyerPersonaModal handleClose={handleCloseBuyerPersonaModal} isCreation={isCreation} />
          )}
          {isOpenBuyerPersonasModal && (
            <BuyerPersonasModal handleCloseModal={closeBuyerPersonasModal} />
          )}
        </>
      ) : (
        <>
          <AccountSettingsTabHeader>
            <AccountSettingsTabHeaderLeft>
              <AccountSettingsTabTitle icon="person">
                <span className={styles._title__container}>
                  <span>Buyer Persona example</span>
                  <span
                    className={styles._lenguage__text__container}
                    onClick={() => setLenguage('EN')}
                  >
                    <Flag code={countries.find(x => x.code === 'GB')?.code} />
                    <Text size="s" color="bloobirds" inline className={styles._lenguage__text}>
                      English example
                    </Text>
                  </span>
                  <span
                    className={styles._lenguage__text__container}
                    onClick={() => setLenguage('ES')}
                  >
                    <Flag code={countries.find(x => x.code === 'ES')?.code} />
                    <Text size="s" color="bloobirds" inline className={styles._lenguage__text}>
                      Ejemplo en español
                    </Text>
                  </span>
                </span>
              </AccountSettingsTabTitle>
            </AccountSettingsTabHeaderLeft>
            <AccountSettingsTabHeaderRight>
              <span onClick={() => setShowExamplePage(false)} className={styles._link}>
                <Icon name="cross" color="bloobirds" size={24} />
              </span>
            </AccountSettingsTabHeaderRight>
          </AccountSettingsTabHeader>
          <AccountSettingsTabContent>
            <ExampleBusinessAsset type={'Buyer Persona'} lenguage={lenguage || 'EN'} />
          </AccountSettingsTabContent>
        </>
      )}
    </AccountSettingsTab>
  );
};

export default BuyerPersonaTab;
